import type { Action, PayloadAction } from "@reduxjs/toolkit";
import * as actions from "./actions";
import type { IActiveProduct } from "./models";

const initialState: IActiveProduct = {
  product: null,
};

export default function activeProductReducer(
  state: IActiveProduct,
  action: Action,
): IActiveProduct {
  if (typeof state === "undefined") {
    return initialState;
  }
  switch (action.type) {
    case actions.UPDATE: {
      const { product } = (action as PayloadAction<IActiveProduct>).payload;
      if (product) {
        const {
          cartType,
          currentCustomer,
        } = window.Verwimp;
        const { locale } = Craft;
        let description = product.description_nl;
        let extendedText = product.extendedText_nl;
        if (locale === 'en') {
          description = product.description_en;
          extendedText = product.extendedText_en;
          // @ts-ignore remap productAttributes based on locale
          product.productAttributes = product.productAttributes ? product.productAttributes.EN : {};
        } else if (locale === 'fr') {
          description = product.description_fr;
          extendedText = product.extendedText_fr;
          // @ts-ignore remap productAttributes based on locale
          product.productAttributes = product.productAttributes ? product.productAttributes.FR : {};
        } else if (locale === 'es') {
          description = product.description_es;
          extendedText = product.extendedText_es;
          // @ts-ignore remap productAttributes based on locale
          product.productAttributes = product.productAttributes ? product.productAttributes.ES : {};
        } else if (locale === 'de') {
          description = product.description_de;
          extendedText = product.extendedText_de;
          // @ts-ignore remap productAttributes based on locale
          product.productAttributes = product.productAttributes ? product.productAttributes.DE : {};
        } else if (locale === 'nl') {
          // @ts-ignore remap productAttributes based on locale
          product.productAttributes = product.productAttributes ? product.productAttributes.NL : {};
        }
        product.description = description;
        product.extendedText = extendedText;

        const allowBackorders = product.hasUnlimitedStock &&
          !product.endOfLive &&
          cartType !== "dropshipment" &&
          currentCustomer &&
          currentCustomer.backorders &&
          !currentCustomer?.prepaidRequired;

        product.allowBackorders = allowBackorders;

        const availableForOrder = allowBackorders ||
          product.totalStock > 0 ||
          (cartType === "dropshipment" && product.dropshipmentAllowed);

        product.availableForOrder = availableForOrder;
      }

      return {
        ...state,
        product,
      };
    }
    case actions.CLEAR: {
      window.document.body.classList.remove('tw:overflow-hidden');
      return {
        ...state,
        product: null,
      };
    }
    default:
      return state;
  }
}
